<template>
  <div class="bg-light border rounded p-2 mb-3 small">
    <div class="fw-semibold">
      {{ title }}
    </div>
    <div class="text-muted mb-1">
      {{ description }}
    </div>
    <ul class="csv-format-columns list-unstyled mb-0">
      <li
        v-for="column in columns"
        :key="column.name"
      >
        <strong>{{ column.name }}</strong>
        <template v-if="column.description">
          - {{ column.description }}
        </template>
        <span
          v-if="column.required"
          class="text-muted ms-1"
        >(required)</span>
      </li>
    </ul>
    <div
      v-if="note"
      class="alert py-1 px-2 mt-2 mb-0"
      :class="note.type === 'warning' ? 'alert-warning' : 'alert-info'"
    >
      {{ note.text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'CSV Format Requirements' },
    description: { type: String, default: 'Your CSV file should contain the following columns:' },
    columns: { type: Array, required: true },
    note: { type: Object, default: null },
  },
};
</script>

<style scoped>
.csv-format-columns {
  columns: 22rem;
}

.csv-format-columns li {
  break-inside: avoid;
}
</style>
